function handleRecaptchaLoaded() {
  document.querySelectorAll('.recaptcha-submit-button').forEach((submit) => submit.classList.remove('disabled'))
  window.removeEventListener('recaptchaLoaded', handleRecaptchaLoaded)
}
if (!window.grecaptchaHandle) {
  window.addEventListener('recaptchaLoaded', handleRecaptchaLoaded)
} else {
  document.querySelectorAll('.recaptcha-submit-button').forEach((submit) => submit.classList.remove('disabled'))
}

async function handleRecaptchaSubmit(e) {
  const action = e.target.dataset.recaptchaAction
  const response = await window.grecaptcha.enterprise.execute(window.grecaptchaHandle, { action })
  document.querySelectorAll('input.g-recaptcha-response').forEach((input) => {
    // eslint-disable-next-line no-param-reassign
    input.value = response
  })
}

const recaptchaSubmitted = new WeakMap()

document.addEventListener('submit', async (e) => {
  if (!e.target.classList.contains('recaptcha-form')) return

  const alreadyProcessed = recaptchaSubmitted.get(e.target)
  if (alreadyProcessed) {
    recaptchaSubmitted.delete(e.target) // Clean up immediately
    return
  }

  e.preventDefault()

  try {
    await handleRecaptchaSubmit(e)

    recaptchaSubmitted.set(e.target, true)

    // Setup cleanup handlers for Turbo frames
    const cleanupRecaptcha = () => {
      recaptchaSubmitted.delete(e.target)
    }
    e.target.addEventListener('turbo:submit-end', cleanupRecaptcha, { once: true })
    e.target.addEventListener('turbo:frame-render', cleanupRecaptcha, { once: true })

    // Now submit the form with the recaptcha token
    // This will trigger the submit event again, but will pass through due to WeakMap check
    e.target.requestSubmit()
  } catch (error) {
    // Ensure WeakMap is clean so user can try again
    recaptchaSubmitted.delete(e.target)
  }
}, true)
